import { Helper } from '@/mixin/helper'

export default [
  {
    path: '/chat',
    name: 'Chat',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/dashboards'),
  },
]
